import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../environments/environment';

export class BaseService {
    private _http: HttpClient;
    protected apiUrl: string;
    public Headers: HttpHeaders;

    constructor(http: HttpClient) {
        this._http = http;
        this.apiUrl = environment.apiUrl;
        if (!environment.production) {
            this.Headers = new HttpHeaders(
                 {'Access-Control-Allow-Origin': 'http://localhost:4200'},
            );
            this.Headers.get('');
        }
    }

    public Delete(url: string): Observable<any> {
        return this._http.delete(this.apiUrl + url, {
            headers: this.Headers,
            withCredentials: true
        }).pipe(catchError(this.HandleError));
    }

    public DeleteWithBody<T>(url: string, body: T): Observable<any> {
        return this._http.request('delete', this.apiUrl + url, {
            body: body,
            headers: this.Headers,
            withCredentials: true
        }).pipe(catchError(this.HandleError));
    }

    public Get(url: string): Observable<any> {
        return this._http.get(encodeURI(this.apiUrl + url), {
            headers: this.Headers,
            withCredentials: true
        }).pipe(
            catchError(this.HandleError)
        );
    }

    public HandleError(error: HttpErrorResponse): Observable<never> {

        return throwError(error);
    }

    public Post<T>(url: string, body: T): Observable<any> {
        return this._http.post(this.apiUrl + url, body, {
            headers: this.Headers,
            withCredentials: true
        }).pipe(
            catchError(this.HandleError)
        );
    }

    public Put<T>(url: string, body: T): Observable<any> {
        return this._http.put(this.apiUrl + url, body, {
            headers: this.Headers,
            withCredentials: true
        }).pipe(catchError(this.HandleError));
    }
}
